import {StepSendEmail} from '@/types/Steps'
import {useIntl} from 'react-intl'

type SendEmailStepInfoProps = {
  stepData: StepSendEmail
}

export const SendEmailStepInfo = ({stepData}: SendEmailStepInfoProps) => {
  const {formatMessage} = useIntl()

  const shouldEmailDisplay = stepData.message_configs[0]?.message?.length > 0

  if (!shouldEmailDisplay) {
    return null
  }

  const subject = stepData.message_configs[0]?.subject
  const message = stepData.message_configs[0]?.message

  return (
    <div className="flex flex-col gap-1" data-testid="step-info-value">
      <span
        className="line-clamp-1 w-fit max-w-56 overflow-hidden overflow-ellipsis"
        data-testid="step-info-subject-value"
      >
        {formatMessage({id: 'SEND_NOTIFICATION_CONTENT.SUBJECT_LABEL'})} : {subject}
      </span>
      <span
        className="line-clamp-2 w-fit max-w-56 overflow-hidden overflow-ellipsis"
        data-testid="step-info-message-value"
      >
        {formatMessage({id: 'SEND_NOTIFICATION_CONTENT.MESSAGE_LABEL'})} : {message}
      </span>
    </div>
  )
}
